import { PageWrapper } from "../../../../shared/components/layout/PageWrapper";
import { useNewDetailPage } from "./useNewDetailPage";
import { NewDetailContent } from "../../components/NewDetailContent/NewDetailContent";

export const NewDetailPage = () => {
  const { newData, isLoading, isErrorNewData, handleNavigateToDashboard } =
    useNewDetailPage();
  return (
    <PageWrapper
      isLoading={isLoading}
      isError={isErrorNewData}
      errorMessage="Error al cargar la novedad. Por favor, intente nuevamente."
      onBack={handleNavigateToDashboard}
      title="Detalle de Novedad"
    >
      {newData && <NewDetailContent newData={newData} />}
    </PageWrapper>
  );
};
